
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "assistantorder",
components: {Tab, TabItem, Group, Cell, XButton},
data() {
return {
dataList: [],
total: 0,
type: 'false',
isAdmin: true,
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
}
},
methods: {
goToRepair(seq) {
this.$router.push({name: 'normalcomplete', query: {seq, role: 'EXPT'}})
},
unfinished() {
this.dataList = [];
this.$http.get('/api/v1/normalrepairs/list_repair_visible_to_me?closed=false&role=EXPT&offset=0&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content]
this.total = response.data.total
})
},
finished() {
this.dataList = [];
this.$http.get('api/v1/normalrepairs/list_repair_visible_to_me?closed=true&role=EXPT&offset=0&count=10', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content]
this.total = response.data.total
})
},
more() {
this.$http.get('api/v1/normalrepairs/list_repair_visible_to_me?role=EXPT&offset=' + this.dataList.length + '&count=10&closed=' + this.type, this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content]
this.total = response.data.total
})
}
},
created() {
const openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
this.$http.get('api/v1/wechat/' + unionid).then((res) => {



if (res.data.length !== 0) {
res.data.forEach(item => {
if (item.role === 'EXPT') {
let account = item.account
localStorage.setItem('account', account)
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then((res) => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
this.header = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
this.unfinished();
})
}
})
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/assistantinfo/assistantorder.vue